import { createContext, useContext } from 'react';

const InventoryChromeContext = createContext({
  openAppMenu: () => {},
});

export function useInventoryChrome() {
  return useContext(InventoryChromeContext);
}

export default InventoryChromeContext;
